import {
  Centred,
  Contents,
} from '../../styles/mixins'

const styles = theme => ({
  centred: {
    ...Centred(theme),
  },
  contents: {
    ...Contents(theme),
  },

  banner: {
    height: '100%',
    minHeight: '60vh',
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center',
  },
  banner_policy: {
    backgroundImage: theme.brand && theme.brand.develop.backgroundGradient,
  },
  banner_services_develop: {
    backgroundImage: theme.brand && theme.brand.develop.backgroundGradient,
  },
  banner_services_devops: {
    backgroundImage: theme.brand && theme.brand.devops.backgroundGradient,
  },
  banner_services_datascience: {
    backgroundImage: theme.brand && theme.brand.datascience.backgroundGradient,
  },
  banner_services_dynamics_365: {
    backgroundImage: theme.brand && theme.brand.dynamics_365.backgroundGradient,
  },
  banner_studies: {
    backgroundImage: theme.brand && theme.brand.studies.backgroundGradient,
  },
  banner_blog: {
    backgroundImage: theme.brand && theme.brand.blog.backgroundGradient,
  },
  banner_shot: {
    backgroundImage: theme.brand && theme.brand.devops.backgroundGradient,
  },
  banner_careers: {
    backgroundImage: theme.brand && theme.brand.careers.backgroundGradient,
  },
  banner_about: {
    backgroundImage: theme.brand && theme.brand.about.backgroundGradient,
  },
  banner_contact: {
    backgroundImage: theme.brand && theme.brand.contact.backgroundGradient,
  },
  banner_thing_dynamics: {
    backgroundImage: theme.brand && theme.brand.dynamics_365.backgroundGradient,
  },
  banner_thing_development: {
    backgroundImage: theme.brand && theme.brand.develop.backgroundGradient,
  },
  banner_thing_devops: {
    backgroundImage: theme.brand && theme.brand.devops.backgroundGradient,
  },
  banner_shot: {
    backgroundImage: theme.brand && theme.brand.dynamics_365.backgroundGradient,
  },
  banner_bg: {
    height: '100%',
    textAlign: 'left',
  },
  bannerSub: {
    color: 'rgba(255,255,255,1)',
    textTransform: 'uppercase',
    fontSize: theme.typography.subheading.fontSize,
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.body2.fontSize,
    },
    lineHeight: 1
  },
  bannerHead: {
    marginTop: -theme.spacing.unit * 3,
    textTransform: 'uppercase',
    color: 'rgb(19, 191, 222)',
    fontWeight: 800,
    lineHeight: 1,
    marginTop: theme.spacing.unit,
    fontSize: theme.typography.display3.fontSize,
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.display1.fontSize,
    },
  },
  bannerHead_services_datascience: {
    color: theme.brand && theme.brand.datascience.offset,
  },
  bannerHead_services_develop: {
    color: theme.brand && theme.brand.develop.offset,
  },
  bannerHead_services_devops: {
    color: theme.brand && theme.brand.devops.offset,
  },
  bannerHead_services_dynamics_365: {
    color: theme.brand && theme.brand.dynamics_365.offset,
  },
  bannerHead_studies: {
    color: theme.brand && theme.brand.studies.offset,
  },
  bannerHead_blog: {
    color: theme.brand && theme.brand.blog.offset,
  },
  bannerHead_careers: {
    color: theme.brand && theme.brand.careers.offset,
  },
  bannerHead_about: {
    color: theme.brand && theme.brand.about.offset,
  },
  bannerHead_shot: {
    color: theme.brand && theme.brand.blog.offset,
  },
  bannerHead_contact: {
    color: theme.brand && theme.brand.contact.offset,
  },
  bannerHead_thing_dynamics: {
    color: theme.brand && theme.brand.dynamics_365.offset,
  },
  bannerHead_thing_development: {
    color: theme.brand && theme.brand.develop.offset,
  },
  bannerHead_thing_devops: {
    color: theme.brand && theme.brand.devops.offset,
  },
  bannerLogo: {
    position: 'absolute',
    right: 200,
    top: 'calc(60vh - 100px)',
    height: 108,
    [theme.breakpoints.down('sm')]: {
      right: 100,
    },
  },
})

export default styles



// WEBPACK FOOTER //
// ./src/components/banner/styles.js